import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import { Divider, Drawer, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useGetUserActivity } from "features/account/service/AccountProfileService";
import { useMemo } from "react";

export default function ActivityLog({ isOpen, onBack, onClose }) {
  const { response } = useGetUserActivity({ category: "affiliated" });
  const activityLogs = useMemo(() => response?.data, [response]);

  return (
    <Drawer
      className='account-profile-drawer'
      anchor='right'
      open={isOpen}
      onClose={onClose}
    >
      <Stack
        className='header'
        direction='row'
        justifyContent='space-between'
        alignItems='center'
      >
        <img
          alt='close-profile-icon'
          className='cursor-pointer'
          src='/images/sidebar/sidebar-back.svg'
          onClick={onBack}
        />
        <p className='account-profile-title'>
          Affiliated Shareholder List Activity Log
        </p>
        <img
          alt='close-profile-icon'
          className='cursor-pointer'
          src='/images/close-profile-icon.svg'
          onClick={onClose}
        />
      </Stack>
      <Stack className='container !pt-0' spacing={3}>
        {activityLogs ? (
          <Stack divider={<Divider />}>
            {activityLogs.map((user) => {
              return (
                <Stack className='w-full'>
                  <Stack className='py-4' spacing={3}>
                    <Stack
                      direction='row'
                      justifyContent='space-between'
                      alignItems='center'
                    >
                      <Stack direction='row' spacing={2} alignItems='center'>
                        {user?.avatar_path ? (
                          <img
                            alt='account-profile-image'
                            src={user.avatar_path}
                            className='w-10 h-10 rounded-full shrink-0 object-cover'
                          />
                        ) : (
                          <AccountCircleRoundedIcon
                            viewBox='2 2 20 20'
                            aria-label='account-profile-image-default'
                            className='p-0'
                            sx={{
                              height: "40px",
                              width: "40px",
                              color: "#ccc",
                            }}
                          />
                        )}
                        <Stack spacing={1} justifyContent='center'>
                          <p
                            className='text-sm'
                            dangerouslySetInnerHTML={{
                              __html: `<strong>${user?.full_name}
                                  </strong> ${user?.action
                                    ?.split("_")?.[0]
                                    ?.toLowerCase()} <strong>${
                                user?.metadata?.name
                              }</strong>`,
                            }}
                          />
                          <Typography fontSize={12} color='#5F737F'>
                            {dayjs(user?.log_time)?.format(
                              "MMM DD, YYYY hh:mmA",
                            )}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              );
            })}
          </Stack>
        ) : (
          <Stack
            justifyContent='center'
            alignItems='center'
            spacing={2}
            className='flex-1'
          >
            <img alt='empty-records' src='/images/empty-watchlist-record.svg' />
          </Stack>
        )}
      </Stack>
    </Drawer>
  );
}
